(function() {
  let hasUpdatedOnMount = false;
  let amountOfClickedTimes = 0;
  class CartItemQuantityUpdate extends HTMLElement {
    step = this.dataset.step ? parseInt(this.dataset.step) : 1;
    steps = this.dataset.steps ? this.dataset.steps.split(",").map((step) => parseInt(step)) : [1];
    quantityControlButtons = Array.from(this.querySelectorAll(".quantity-control-button"));
    inputElement = this.querySelector(".quantity-control-input");
    productTitle = this.dataset.producttitle || "";
    optionOne = this.dataset.optionone || "";
    optionTwo = this.dataset.optiontwo || "";
    optionThree = this.dataset.optionthree || "";
    optionOneName = this.dataset.optiononename || "";
    optionTwoName = this.dataset.optiontwoname || "";
    optionThreeName = this.dataset.optionthreename || "";
    sizeOptionName = this.dataset.sizeoptionname || "";
    uniqueId = this.dataset.uniqueid || "";
    itemKey = this.dataset.itemkey || "";
    handle = this.dataset.handle || "";
    debounceTimeout = 700;
    loadingOverlay = document.getElementById("loading-overlay");
    totalAmountOfProducts = this.dataset.totalamountofproducts || "";
    updateOnMount = this.dataset.updateonmount || "";
    clickedAmountOfTimes = 0;
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListeners();
      if (this.dataset.updateonmount === "true" && !hasUpdatedOnMount) {
        hasUpdatedOnMount = true;
        this.handleQuantityChange();
      }
    }
    addEventListeners() {
      this.quantityControlButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.handleQuantityButtonClicked(button);
        });
      });
      this.inputElement.addEventListener("change", (event) => {
        event.preventDefault();
        this.handleInputChange();
      });
    }
    handleQuantityButtonClicked(button) {
      const currentValue = parseInt(this.inputElement.value);
      const { option } = button.dataset;
      if (option === "minus") {
        this.inputElement.value = (currentValue - this.step).toString();
      } else if (option === "plus") {
        this.inputElement.value = (currentValue + this.step).toString();
      }
      amountOfClickedTimes++;
      if (amountOfClickedTimes === 2) {
        this.toggleTooltip();
      }
      this.debounce(() => this.handleQuantityChange(), this.debounceTimeout);
    }
    toggleTooltip() {
      console.log("Toggle tooltip");
      const tooltip = this.closest(".tw\\:relative").querySelector(".edition-tooltip");
      tooltip.classList.add("edition-tooltip-visible");
      setTimeout(() => {
        tooltip.style.opacity = "0";
        setTimeout(() => {
          tooltip.classList.remove("edition-tooltip-visible");
        }, 4500);
      }, 4500);
    }
    handleInputChange() {
      let currentValue = parseInt(this.inputElement.value);
      if (currentValue % this.step !== 0) {
        currentValue = Math.ceil(currentValue / this.step) * this.step;
        this.inputElement.value = currentValue.toString();
      }
      this.debounce(() => this.handleQuantityChange(), this.debounceTimeout);
    }
    debounce(callback, delay) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = window.setTimeout(callback, delay);
    }
    async handleQuantityChange() {
      this.setLoadingState(true);
      const currentSelectedQuantityOption = parseInt(this.optionOne);
      const currentValue = parseInt(this.inputElement.value);
      const getTotalAndStep = async () => {
        console.log(this.uniqueId);
        const total = await this.getTotalQuantity(this.uniqueId);
        console.log("Total quantity", total);
        const step = this.steps.reduce((acc, step2) => total >= step2 ? step2 : acc, 1);
        return { total, step };
      };
      const updateQuantityData = [{ key: this.itemKey, quantity: currentValue }];
      await this.updateQuantity(updateQuantityData, true);
      const { total: newTotal, step: newStep } = await getTotalAndStep();
      if (newStep !== currentSelectedQuantityOption) {
        console.log("We need to change the variants");
        await this.changeVariants(newStep);
      }
      this.setLoadingState(false);
    }
    async getTotalQuantity(id) {
      const cart = await this.getCart();
      const items = cart.items;
      const filteredItems = items.filter((item) => item.properties._customization === id || item.properties._farvebundle === id || item.properties._BundleID === id);
      if (filteredItems.length > 0) {
        const total = filteredItems.reduce((acc, item) => acc + item.quantity, 0);
        console.log("Total quantity of items with matching ID:", total);
        return total;
      }
      const matchingItems = items.filter((item) => item.product_title === this.productTitle && item.options_with_values[1]?.name === this.sizeOptionName && item.options_with_values[1]?.value === this.optionTwo);
      if (matchingItems.length > 0) {
        const total = matchingItems.reduce((acc, item) => acc + item.quantity, 0);
        console.log("Total quantity of matching product + size:", total);
        return total;
      }
      const titleMatchItems = items.filter((item) => item.product_title === this.productTitle);
      if (titleMatchItems.length > 0) {
        const total = titleMatchItems.reduce((acc, item) => acc + item.quantity, 0);
        console.log("Total quantity of matching product title:", total);
        return total;
      }
      console.log("No matching items found");
      return 0;
    }
    async getCart() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) {
          throw new Error("Could not fetch cart");
        }
        return await response.json();
      } catch (error) {
        console.error(error);
      }
    }
    async updateQuantity(itemsToUpdate, rerender) {
      const updates = itemsToUpdate.reduce(
        (acc, { key, quantity }) => {
          acc[key] = quantity;
          return acc;
        },
        {}
      );
      const sectionsData = this.getSectionsToUpdate().map((section) => section.section).join(",");
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        // sections is a string of comma separated section ids
        body: JSON.stringify({
          updates,
          sections: sectionsData
        })
      });
      if (!response.ok) {
        throw new Error("Could not update quantity");
      }
      const data = await response.json();
      if (rerender) {
        const sections = data.sections;
        this.updateSections(sections);
      }
    }
    updateSections(sections) {
      this.getSectionsToUpdate().forEach((section) => {
        const sectionData = sections[section.section];
        const sectionElement = document.getElementById(section.id);
        if (!sectionElement) {
          return;
        }
        sectionElement.innerHTML = sectionData;
      });
    }
    getSectionsToUpdate() {
      return [
        {
          id: "main-items",
          section: document.getElementById("main-items").dataset.id,
          selector: ".js-contents"
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section"
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section"
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents"
        }
      ];
    }
    // Change variants for the affected line items. In some cases we only have one product, but in some cases we have multiple products (unique ids)
    async changeVariants(step) {
      const variantsInfo = this.querySelector('script[type="text/json"]');
      const parsedVariants = JSON.parse(variantsInfo.innerHTML);
      const cart = await this.getCart();
      let items = cart.items;
      const itemsToRemove = [];
      const itemsToAdd = [];
      let filteredItems = items.filter((item) => item.properties._customization === this.uniqueId || item.properties._farvebundle === this.uniqueId || item.properties._BundleID === this.uniqueId);
      if (filteredItems.length > 0) ;
      else {
        filteredItems = items.filter((item) => item.product_title === this.productTitle && (!item.options_with_values?.[1] || item.options_with_values?.[1]?.name === this.optionTwoName && item.options_with_values?.[1]?.value === this.optionTwo && this.optionTwoName === this.sizeOptionName));
      }
      if (filteredItems.length === 0) {
        filteredItems = items.filter((item) => item.product_title === this.productTitle);
      }
      console.log("filteredItems", filteredItems);
      filteredItems.forEach(async (item) => {
        const variantOptions = item.variant_options;
        variantOptions[0];
        const optionTwo = variantOptions[1];
        const optionThree = variantOptions[2];
        const newVariant = parsedVariants.find((variant) => {
          const matchesOptionOne = variant.option1 === step.toString();
          const matchesOptionTwo = optionTwo ? variant.option2 === optionTwo : true;
          const matchesOptionThree = optionThree ? variant.option3 === optionThree : true;
          return matchesOptionOne && matchesOptionTwo && matchesOptionThree;
        });
        const newVariantId = newVariant?.id;
        if (!newVariantId) {
          console.log("Could not find a new variant id");
          return;
        }
        const props = this.generateItemProperties(item.properties, newVariant);
        itemsToAdd.push({ newVariantId, quantity: item.quantity, props });
        itemsToRemove.push({ key: item.key, quantity: 0 });
      });
      if (itemsToRemove.length > 0) {
        await this.updateQuantity(itemsToRemove, false);
      }
      if (itemsToAdd.length > 0) {
        await this.addVariantToCart(itemsToAdd, true);
      }
    }
    formatMoney(amount) {
      const locale = Shopify.locale;
      let localeString;
      if (locale.includes("en")) {
        localeString = "en-US";
      } else {
        localeString = "da-DK";
      }
      const currency = Shopify.currency.active;
      return amount.toLocaleString(localeString, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
    generateItemProperties(properties, variant) {
      const unitPriceTranslation = window.translateStrings.stkPris;
      if (properties[unitPriceTranslation]) {
        const newUnitPrice = variant.price / 100;
        const newUnitPriceString = this.formatMoney(newUnitPrice);
        properties[unitPriceTranslation] = newUnitPriceString;
      }
      return properties;
    }
    async addVariantToCart(addToCartData, rerender) {
      const formData = {
        items: addToCartData.map(({ newVariantId, quantity, props }) => ({
          id: newVariantId,
          // Shopify expects 'id' instead of 'newVariantId'
          quantity,
          properties: props
          // Include additional properties
        }))
      };
      const sectionsData = this.getSectionsToUpdate().map((section) => section.section).join(",");
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          sections: sectionsData
        })
      });
      if (!response.ok) {
        throw new Error("Could not add variants to cart");
      }
      const data = await response.json();
      if (rerender) {
        const sections = data.sections;
        this.updateSections(sections);
      }
    }
    setLoadingState(loading) {
      this.loadingOverlay.style.display = loading ? "flex" : "none";
    }
  }
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.handleRemove = this.handleRemove.bind(this);
      this.handleMultiRemove = this.handleMultiRemove.bind(this);
    }
    connectedCallback() {
      this.addEventListener("click", this.onClick.bind(this));
    }
    async onClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const key = button.dataset.key;
      const customid = button.dataset.customid || null;
      if (customid) {
        await this.handleMultiRemove(customid);
      } else if (key) {
        await this.handleRemove(key);
      }
    }
    async handleRemove(key) {
      try {
        const cartItemQuantityUpdateControls = document.querySelector(`cart-item-quantity-update[data-itemkey="${key}"]`);
        if (cartItemQuantityUpdateControls) {
          const inputElement = cartItemQuantityUpdateControls.querySelector("input");
          inputElement.value = "0";
          inputElement.dispatchEvent(new Event("change"));
          return;
        }
        this.updateCart({ [key]: 0 });
      } catch (error) {
        console.error("Error removing item:", error);
      }
    }
    async handleMultiRemove(customid) {
      try {
        const cart = await this.getCart();
        const itemsToRemove = cart.items.filter((item) => item.properties["_customizationID"] === customid || item.properties["_customization"] === customid || item.properties["_farvebundle"] === customid);
        if (itemsToRemove.length) {
          const updates = itemsToRemove.reduce((acc, item) => {
            acc[item.key] = 0;
            return acc;
          }, {});
          await this.updateCart(updates);
        }
      } catch (error) {
        console.error("Error removing multiple items:", error);
      }
    }
    async updateCart(updates) {
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error("Failed to update cart");
        window.location.reload();
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    }
    async getCart() {
      try {
        const response = await fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } });
        if (!response.ok) throw new Error("Failed to fetch cart");
        return response.json();
      } catch (error) {
        console.error("Error fetching cart:", error);
        return { items: [] };
      }
    }
  }
  const styles = {
    INFO: "color: #3B82F6; font-weight: bold;",
    SUCCESS: "color: #10B981; font-weight: bold;",
    WARN: "color: #F59E0B; font-weight: bold;",
    ERROR: "color: #EF4444; font-weight: bold;"
  };
  const createLogEntry = (level, message, additionalData, includeStack = false) => {
    const timestamp = (/* @__PURE__ */ new Date()).toISOString();
    let logMessage;
    let logData = additionalData;
    if (typeof message === "string") {
      logMessage = message;
    } else if (typeof message === "object" && message !== null) {
      logMessage = "Object logged";
      logData = message;
    } else {
      logMessage = String(message);
    }
    const entry = {
      timestamp,
      level,
      message: logMessage
    };
    if (logData !== void 0) {
      entry.data = logData;
    }
    if (includeStack) {
      const stack = new Error().stack;
      if (stack) {
        entry.stack = stack.split("\n").slice(3).join("\n");
      }
    }
    if (typeof window !== "undefined") {
      entry.context = {
        url: window.location.href,
        userAgent: navigator.userAgent,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      };
    }
    return entry;
  };
  const logWithStyle = (consoleMethod, level, entry) => {
    console[consoleMethod](`%c[${level}]`, styles[level], entry);
  };
  const logger = {
    info: (message, data) => {
      const entry = createLogEntry("INFO", message, data);
      logWithStyle("log", "INFO", entry);
    },
    success: (message, data) => {
      const entry = createLogEntry("SUCCESS", message, data);
      logWithStyle("log", "SUCCESS", entry);
    },
    warn: (message, data) => {
      const entry = createLogEntry("WARN", message, data, true);
      logWithStyle("warn", "WARN", entry);
    },
    error: (message, data) => {
      const entry = createLogEntry("ERROR", message, data, true);
      logWithStyle("error", "ERROR", entry);
    }
  };
  class StorageHelper {
    storage = null;
    type;
    isAvailable = false;
    constructor(type) {
      this.type = type;
      this.checkAvailability();
    }
    /**
     * Check if storage is available (handles private browsing, etc.)
     */
    checkAvailability() {
      try {
        const storage = window[this.type];
        const testKey = "__storage_test__";
        storage.setItem(testKey, "test");
        storage.removeItem(testKey);
        this.storage = storage;
        this.isAvailable = true;
      } catch (e) {
        this.isAvailable = false;
        logger.warn(`${this.type} is not available`, { error: e });
      }
    }
    /**
     * Set an item in storage
     */
    set(key, value, expiresInMinutes) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        const item = { value };
        if (expiresInMinutes) {
          item.expires = Date.now() + expiresInMinutes * 60 * 1e3;
        }
        this.storage.setItem(key, JSON.stringify(item));
        return true;
      } catch (e) {
        logger.error("Failed to set storage item", { key, error: e });
        return false;
      }
    }
    /**
     * Get an item from storage
     */
    get(key) {
      if (!this.isAvailable || !this.storage) return null;
      try {
        const raw = this.storage.getItem(key);
        if (!raw) return null;
        const item = JSON.parse(raw);
        if (item.expires && Date.now() > item.expires) {
          this.remove(key);
          return null;
        }
        return item.value;
      } catch (e) {
        logger.error("Failed to get storage item", { key, error: e });
        return null;
      }
    }
    /**
     * Remove an item from storage
     */
    remove(key) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.removeItem(key);
        return true;
      } catch (e) {
        logger.error("Failed to remove storage item", { key, error: e });
        return false;
      }
    }
    /**
     * Clear all items from storage
     */
    clear() {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.clear();
        return true;
      } catch (e) {
        logger.error("Failed to clear storage", { error: e });
        return false;
      }
    }
    /**
     * Check if a key exists in storage
     */
    has(key) {
      if (!this.isAvailable || !this.storage) return false;
      return this.storage.getItem(key) !== null;
    }
    /**
     * Get all keys in storage
     */
    keys() {
      if (!this.isAvailable || !this.storage) return [];
      const keys = [];
      for (let i = 0; i < this.storage.length; i++) {
        const key = this.storage.key(i);
        if (key) keys.push(key);
      }
      return keys;
    }
    /**
     * Get storage size in bytes (approximate)
     */
    size() {
      if (!this.isAvailable || !this.storage) return 0;
      let total = 0;
      for (let i = 0; i < this.storage.length; i++) {
        const key = this.storage.key(i);
        if (key) {
          const value = this.storage.getItem(key);
          if (value) {
            total += key.length + value.length;
          }
        }
      }
      return total;
    }
    /**
     * Create a namespaced storage helper
     * Prefixes all keys with the namespace
     */
    namespace(prefix) {
      return new NamespacedStorage(this, prefix);
    }
    /**
     * Check if storage is available
     */
    get available() {
      return this.isAvailable;
    }
  }
  class NamespacedStorage {
    constructor(storage, prefix) {
      this.storage = storage;
      this.prefix = prefix;
    }
    storage;
    prefix;
    getKey(key) {
      return `${this.prefix}:${key}`;
    }
    set(key, value, expiresInMinutes) {
      return this.storage.set(this.getKey(key), value, expiresInMinutes);
    }
    get(key) {
      return this.storage.get(this.getKey(key));
    }
    remove(key) {
      return this.storage.remove(this.getKey(key));
    }
    has(key) {
      return this.storage.has(this.getKey(key));
    }
    /**
     * Clear all items in this namespace
     */
    clear() {
      const keys = this.storage.keys().filter((key) => key.startsWith(`${this.prefix}:`));
      let success = true;
      keys.forEach((key) => {
        if (!this.storage.remove(key)) {
          success = false;
        }
      });
      return success;
    }
    /**
     * Get all keys in this namespace (without prefix)
     */
    keys() {
      const prefixLength = this.prefix.length + 1;
      return this.storage.keys().filter((key) => key.startsWith(`${this.prefix}:`)).map((key) => key.substring(prefixLength));
    }
  }
  const local = new StorageHelper("localStorage");
  new StorageHelper("sessionStorage");
  const CONSENT_STORAGE_KEY$1 = "cookieSelections";
  const CONSENT_DENIED_DEFAULTS = {
    personalization: false,
    marketing: false,
    analytics: false
  };
  const CONSENT_KEYS = ["personalization", "marketing", "analytics"];
  class CookieBanner extends HTMLElement {
    consentApiReady = false;
    async connectedCallback() {
      console.log("CookieBanner: connectedCallback");
      await this.setupConsent();
      this.addEventListeners();
      this.activateTab("consent");
      this.syncCheckboxGroups();
      if (this.dataset.forceShow === "true" || await this.shouldShowBanner()) {
        console.log("CookieBanner: showing banner");
        this.showBanner();
      }
    }
    /** Sets gtag consent defaults, fires `edition:consent-default-set`, and optionally loads GTM. */
    setupConsent = async () => {
      this.ensureGtag();
      const selections = local.get(CONSENT_STORAGE_KEY$1) ?? CONSENT_DENIED_DEFAULTS;
      window.gtag?.("consent", "default", {
        functionality_storage: "granted",
        analytics_storage: selections.analytics ? "granted" : "denied",
        personalization_storage: selections.personalization ? "granted" : "denied",
        ad_personalization: selections.personalization ? "granted" : "denied",
        ad_storage: selections.marketing ? "granted" : "denied",
        ad_user_data: selections.marketing ? "granted" : "denied",
        wait_for_update: 3e3
      });
      window.gtag?.("set", "ads_data_redaction", !selections.marketing);
      window.gtag?.("set", "url_passthrough", true);
      window.dispatchEvent(new CustomEvent("edition:consent-default-set"));
      await this.loadShopifyConsentApi();
    };
    addEventListeners = () => {
      this.querySelector("#tab-consent")?.addEventListener("click", () => this.activateTab("consent"));
      this.querySelector("#tab-details")?.addEventListener("click", () => this.activateTab("details"));
      this.querySelector(".allow-all-btn")?.addEventListener("click", this.handleAllowAll);
      this.querySelector(".allow-selected-btn")?.addEventListener("click", this.handleAllowSelected);
      this.querySelector('[data-action="reject"]')?.addEventListener("click", this.handleRejectAll);
      document.getElementById("manage-cookie-consent")?.addEventListener("click", (event) => {
        event.preventDefault();
        this.showBanner();
      });
    };
    activateTab = (tab) => {
      ["consent", "details"].forEach((id) => {
        this.querySelector(`#tab-${id}`)?.classList.toggle("active", id === tab);
        this.querySelector(`#panel-${id}`)?.classList.toggle("active", id === tab);
        this.querySelector(`#panel-${id}`)?.classList.toggle("tw:hidden!", id !== tab);
      });
    };
    /**
     * Returns true if the banner should be shown.
     * Prefers localStorage over the Shopify API — if the user has a stored selection we trust it
     * and skip the async API call entirely.
     */
    shouldShowBanner = async () => {
      if (local.get(CONSENT_STORAGE_KEY$1)) {
        return false;
      }
      if (!this.consentApiReady || !window.Shopify?.customerPrivacy?.currentVisitorConsent) {
        return true;
      }
      try {
        const { preferences, analytics, marketing } = await window.Shopify.customerPrivacy.currentVisitorConsent();
        return [preferences, analytics, marketing].every((v) => (v ?? "") === "");
      } catch {
        return true;
      }
    };
    loadShopifyConsentApi = () => {
      if (!window.Shopify?.loadFeatures) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        try {
          window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
            if (error) {
              logger.error("Shopify consent-tracking-api failed to load", error);
              resolve();
              return;
            }
            this.consentApiReady = true;
            resolve();
            document.addEventListener("visitorConsentCollected", async () => {
              try {
                const v = await window.Shopify?.customerPrivacy?.currentVisitorConsent?.();
                if (!v) {
                  return;
                }
                this.setConsentGroup({
                  key: "personalization",
                  checked: v.preferences === "yes"
                });
                this.setConsentGroup({
                  key: "marketing",
                  checked: v.marketing === "yes"
                });
                this.setConsentGroup({
                  key: "analytics",
                  checked: v.analytics === "yes"
                });
                this.saveSelections();
              } catch (err) {
                logger.error("visitorConsentCollected handler error", err);
              }
            });
          });
        } catch (e) {
          logger.error("Shopify loadFeatures threw", e);
          resolve();
        }
      });
    };
    /** Updates gtag consent, persists to localStorage, and fires `edition:consent-updated`. */
    applyConsent = ({ consent, hide }) => {
      window.gtag?.("consent", "update", {
        functionality_storage: "granted",
        analytics_storage: consent.analytics === "yes" ? "granted" : "denied",
        personalization_storage: consent.preferences === "yes" ? "granted" : "denied",
        ad_personalization: consent.preferences === "yes" ? "granted" : "denied",
        ad_storage: consent.marketing === "yes" ? "granted" : "denied",
        ad_user_data: consent.marketing === "yes" ? "granted" : "denied"
      });
      window.gtag?.("set", "ads_data_redaction", consent.marketing !== "yes");
      this.saveSelections();
      window.dispatchEvent(new CustomEvent("edition:consent-updated"));
      window.Shopify?.customerPrivacy?.setTrackingConsent?.({
        analytics: consent.analytics === "yes",
        marketing: consent.marketing === "yes",
        preferences: consent.preferences === "yes"
      });
      if (hide) {
        this.hideBanner();
      }
    };
    handleAllowAll = () => {
      this.querySelectorAll("input.ed-checkbox[data-consent]").forEach((cb) => {
        if (!cb.disabled) {
          cb.checked = true;
        }
      });
      this.applyConsent({
        consent: { preferences: "yes", marketing: "yes", analytics: "yes" },
        hide: true
      });
    };
    handleAllowSelected = () => {
      const { personalization, marketing, analytics } = this.getSelections();
      this.applyConsent({
        consent: {
          preferences: personalization ? "yes" : "no",
          marketing: marketing ? "yes" : "no",
          analytics: analytics ? "yes" : "no"
        },
        hide: true
      });
    };
    handleRejectAll = () => {
      this.applyConsent({
        consent: { preferences: "no", marketing: "no", analytics: "no" },
        hide: true
      });
    };
    /** Keeps the consent/details tab panels in sync — the same consent key can appear in both tabs. */
    syncCheckboxGroups = () => {
      const checkboxes = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", ({ currentTarget }) => {
          const source = currentTarget;
          checkboxes.forEach((other) => {
            if (other !== source && other.dataset.consent === source.dataset.consent && !other.disabled) {
              other.checked = source.checked;
            }
          });
        });
      });
      const grouped = checkboxes.reduce((acc, cb) => {
        const key = cb.dataset.consent;
        (acc[key] ??= []).push(cb);
        return acc;
      }, {});
      Object.values(grouped).forEach(([source, ...rest]) => {
        rest.forEach((cb) => {
          if (!cb.disabled) {
            cb.checked = source.checked;
          }
        });
      });
    };
    setConsentGroup = ({ key, checked }) => {
      this.querySelectorAll(`input.ed-checkbox[data-consent="${key}"]`).forEach((cb) => {
        if (!cb.disabled) {
          cb.checked = checked;
        }
      });
    };
    saveSelections = () => {
      local.set(CONSENT_STORAGE_KEY$1, this.getSelections());
    };
    getSelections = () => CONSENT_KEYS.reduce(
      (acc, key) => ({
        ...acc,
        [key]: !!this.querySelector(`input.ed-checkbox[data-consent="${key}"]`)?.checked
      }),
      { personalization: false, marketing: false, analytics: false }
    );
    get overlay() {
      return this.querySelector("[data-cookie-overlay]") ?? this;
    }
    /**
     * Opens the banner. Applies any previously saved selections to the checkboxes first —
     * if nothing is stored, the HTML defaults remain as-is.
     * Can be triggered externally via `#manage-cookie-consent`.
     */
    showBanner = () => {
      const saved = local.get(CONSENT_STORAGE_KEY$1);
      if (saved) {
        CONSENT_KEYS.forEach((key) => this.setConsentGroup({ key, checked: saved[key] }));
      }
      this.overlay.removeAttribute("hidden");
      this.overlay.classList.remove("tw:hidden!");
    };
    hideBanner = () => {
      this.overlay.classList.add("tw:hidden!");
    };
    /** Creates a `window.gtag` shim that queues calls into `dataLayer` if the real gtag hasn't loaded yet. */
    ensureGtag = () => {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
      }
    };
  }
  function setCookie(name, value, minutes) {
    document.cookie = `${name}=${value};max-age=600000;path=/;SameSite=Lax;Secure;domain=${window.location.hostname}`;
    console.log(`Cookie set: ${name}=${value}; max-age=60000; path=/; SameSite=Lax; Secure; domain=${window.location.hostname}`);
  }
  function getCookie(name) {
    const cookies = document.cookie.split(";");
    const foundCookie = cookies.find((cookie) => {
      const [cookieName] = cookie.split("=");
      return cookieName.trim() === name;
    });
    return foundCookie?.split("=")[1];
  }
  class Geolocator extends HTMLElement {
    countryData = window.countryData;
    url = window.location.href;
    cookieDuration = this.dataset.ookieduration;
    constructor() {
      super();
      this.getSelectedCountry = this.getSelectedCountry.bind(this);
      this.getVisitorCountry = this.getVisitorCountry.bind(this);
      this.showGeoPopup = this.showGeoPopup.bind(this);
      this.handleClickedStayButton = this.handleClickedStayButton.bind(this);
      this.handleClickedRedirectButton = this.handleClickedRedirectButton.bind(this);
      this.checkUrlForParam = this.checkUrlForParam.bind(this);
    }
    async connectedCallback() {
      this.checkUrlForParam();
      console.log("Geolocator connected");
      if (getCookie("edition-geocookie") || getCookie("edition-geoswitch") || window.Shopify?.designMode === true) {
        return;
      }
      const { countryData } = window;
      const selectedCountry = this.getSelectedCountry();
      const visitorCountry = await this.getVisitorCountry();
      console.log("Selected country: ", selectedCountry);
      console.log("Visitor country: ", visitorCountry);
      if (selectedCountry.countryCode === visitorCountry.handle) ;
      else {
        const visitorCountryIsInCountryData = countryData.some((country) => country.countryCode === visitorCountry.handle);
        if (!visitorCountryIsInCountryData) {
          const primaryCountryDataInCountryData = countryData.find((country) => country.primaryCountry === true);
          if (selectedCountry.countryCode === primaryCountryDataInCountryData.countryCode) {
            return;
          }
          this.showGeoPopup(primaryCountryDataInCountryData);
        } else {
          const visitorCountryDataInCountryData = countryData.find((country) => country.countryCode === visitorCountry.handle);
          console.log("Visitor country data in country data: ", visitorCountryDataInCountryData);
          this.showGeoPopup(visitorCountryDataInCountryData);
        }
      }
    }
    getSelectedCountry() {
      const countryDataArray = window.countryData;
      const selectedCountry = countryDataArray.find((country) => country.countryCode === Shopify.country && country.locale === Shopify.locale) || countryDataArray.find((country) => country.countryCode === Shopify.country);
      return selectedCountry;
    }
    async getVisitorCountry() {
      const response = await fetch("/browsing_context_suggestions.json");
      const data = await response.json();
      const visitorCountry = data.detected_values.country;
      this.setAttribute("data-visitor-country", visitorCountry.handle);
      return visitorCountry;
    }
    showGeoPopup(countryObject) {
      this.classList.remove("tw:z-[-1]");
      this.classList.add("tw:z-[100]");
      setTimeout(() => {
        this.classList.add("tw:opacity-100!");
      }, 500);
      const { layout } = this.dataset;
      if (layout === "primary") {
        const img = this.querySelector("#geolocator-flag");
        const heading = this.querySelector("#geolocator-heading");
        const richtext = this.querySelector("#geolocator-richtext");
        const buttonRedirect = this.querySelector("#geolocator-button-redirect");
        const buttonStay = this.querySelector("#geolocator-button-stay");
        if (img && countryObject.flag !== "") {
          img.src = countryObject.flag;
        } else {
          img.remove();
        }
        heading.innerHTML = countryObject.heading;
        richtext.innerText = countryObject.richtext;
        buttonRedirect.innerHTML = countryObject.button_one;
        buttonStay.innerHTML = countryObject.button_two;
        buttonRedirect.addEventListener("click", this.handleClickedRedirectButton.bind(this, countryObject));
        buttonStay.addEventListener("click", this.handleClickedStayButton.bind(this));
      } else {
        const heading = this.querySelector("#geolocator-heading");
        const richtext = this.querySelector("#geolocator-richtext");
        const buttonStay = this.querySelector("#geolocator-button-stay");
        this.SortAndOrderCountries(countryObject);
        heading.innerHTML = countryObject.heading;
        richtext.innerHTML = countryObject.richtext;
        buttonStay.innerHTML = countryObject.button_two;
        buttonStay.addEventListener("click", this.handleClickedStayButton.bind(this));
      }
    }
    handleClickedStayButton() {
      this.classList.remove("tw:opacity-100");
      this.classList.add("tw:opacity-0");
      setCookie("edition-geocookie", "true");
      setTimeout(() => {
        this.remove();
      }, 1e3);
    }
    handleClickedRedirectButton(countryObject) {
      this.remove();
      const storeType = countryObject.type;
      const marketList = countryObject.market_list.split(",");
      const currentUrl = window.origin;
      let currentStoreIsInMarketList = false;
      marketList.forEach((market) => {
        market = market.replace("www.", "");
        if (currentUrl.includes(market)) {
          currentStoreIsInMarketList = true;
        }
      });
      if (storeType === "Country" && !currentStoreIsInMarketList) {
        const redirectUrl = countryObject.link;
        window.location.href = redirectUrl;
      } else if (storeType === "Market" && currentStoreIsInMarketList) {
        const code = countryObject.countryCode;
        const countryLocale = countryObject.locale;
        this.updateLocalization(code, countryLocale);
      } else {
        const redirectUrl = countryObject.link;
        window.location.href = redirectUrl;
      }
    }
    checkUrlForParam() {
      if (this.url.includes("?edition-geoswitch")) {
        parseInt(this.cookieDuration, 10) * 24 * 60;
        setCookie("edition-geoswitch", "true");
      }
    }
    SortAndOrderCountries(countryObject) {
      const currentCountryListHolder = this.querySelector("#geolocator-country-list");
      const currentCountryList = Array.from(currentCountryListHolder.querySelectorAll(".geolocator_country"));
      currentCountryList.sort((a, b) => {
        if (a.dataset.locale === countryObject.locale) {
          return -1;
        }
        if (b.dataset.locale === countryObject.locale) {
          return 1;
        }
        return 0;
      });
      currentCountryList.forEach((country) => {
        currentCountryListHolder.appendChild(country);
      });
    }
    // eslint-disable-next-line class-methods-use-this
    updateLocalization(countryCode, countryLocale) {
      const randomFormId = Math.random().toString(36).substring(7);
      const formHtml = `
    <form id="${randomFormId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${countryCode}">
      <input name="language_code" value="${countryLocale}">
    </form>
  `;
      document.body.insertAdjacentHTML("beforeend", formHtml);
      const form = document.getElementById(randomFormId);
      form.submit();
    }
  }
  class GoogleCookie {
    constructor() {
      this.init = this.init.bind(this);
    }
    init() {
      this.checkUrlForGclid();
      const offlineCookie = this.getCookie("offline_tracking_cookie");
      const contactProductForm = document.getElementById("contact_product-form");
      const contactForm = document.getElementById("ContactForm");
      if (offlineCookie && contactProductForm) {
        const hiddenInput = `<input type="hidden"
      name="contact[offlinecookie]" value="${offlineCookie}">`;
        const form = contactProductForm.querySelector("form");
        form.insertAdjacentHTML("beforeend", hiddenInput);
      }
      if (offlineCookie && contactForm) {
        const hiddenInput = `<input type="hidden"
      name="contact[offlinecookie]" value="${offlineCookie}">`;
        contactForm.insertAdjacentHTML("beforeend", hiddenInput);
      }
    }
    checkUrlForGclid() {
      const urlParams = new URLSearchParams(window.location.search);
      const gclid = urlParams.get("gclid");
      if (gclid) {
        this.setCookie("offline_tracking_cookie", gclid);
        return true;
      }
      return false;
    }
    setCookie(name, value, days = 30) {
      const date = /* @__PURE__ */ new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }
  const CHANGE_EVENT = "quantity-breaks:change";
  const tierForQuantity = (tiers, quantity) => tiers.find((tier) => quantity >= tier.from && (tier.to === null || quantity <= tier.to));
  const shopifyRoot = () => window.Shopify?.routes?.root ?? "/";
  const escapeHtml = (value) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>';
  const ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
  const ICON_CARET = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';
  class QuantityBreaks extends HTMLElement {
    config;
    texts;
    formatMoney;
    /** Option values per option position, in first-seen (variant) order. */
    optionValues = [];
    selectedOptions = [];
    /** Quantity the shopper typed/stepped; null = untouched (defaults to tier 1's lower bound). */
    enteredQuantity = null;
    /** True while the CTA is adding to cart / handing off to the designer. */
    isSubmitting = false;
    /** Variant id the tier select's options were last built for. */
    renderedTiersForVariantId = null;
    quantityField;
    quantityInput;
    tierField;
    tierSelect;
    optionSelects = [];
    summaryGrid;
    feeColumn;
    summarySpacer;
    summaryValueElements = {};
    ctaButton;
    connectedCallback() {
      if (this.dataset.mounted === "true") {
        return;
      }
      const config = this.readConfig();
      if (!config) {
        return;
      }
      this.config = config;
      if (this.config.quantityBreaks?.version !== 2) {
        return;
      }
      this.dataset.mounted = "true";
      this.texts = this.config.texts;
      this.buildFormatMoney();
      this.initSelection();
      this.buildDom();
      this.bindEvents();
      this.update();
    }
    /** The sibling JSON config script rendered by the Liquid snippet. */
    readConfig() {
      const sibling = this.previousElementSibling;
      const script = sibling?.matches("script[data-quantity-breaks-config]") ? sibling : this.parentElement?.querySelector("script[data-quantity-breaks-config]");
      if (!script?.textContent) {
        return null;
      }
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error("[quantity-breaks] invalid config JSON", error);
        return null;
      }
    }
    /**
     * The moms multiplier, exactly like the legacy calculator: the THEME's
     * moms_value when moms display is enabled, 1 when it is not (e.g. the CH
     * store) — no moms lines are shown at all in that case.
     */
    get momsMultiplier() {
      return this.config.momsEnabled && this.config.moms > 0 ? this.config.moms : 1;
    }
    buildFormatMoney() {
      const display = this.config.currencyDisplay ?? "value_symbol";
      const useCode = display.includes("code");
      const currencyFirst = !display.startsWith("value");
      const { currency, locale } = this.config;
      const formatter = new Intl.NumberFormat(locale || "da", { style: "currency", currency, currencyDisplay: useCode ? "code" : "narrowSymbol" });
      this.formatMoney = (amount) => {
        const parts = formatter.formatToParts(amount);
        const currencyToken = parts.find((part) => part.type === "currency")?.value ?? currency;
        const number = parts.filter((part) => part.type !== "currency" && part.type !== "literal").map((part) => part.value).join("");
        return currencyFirst ? `${currencyToken} ${number}` : `${number} ${currencyToken}`;
      };
    }
    /** A ?variant= in the URL (shared link, reload) wins over the first available variant. */
    initSelection() {
      const { product } = this.config;
      this.optionValues = product.options.map((_, index) => [...new Set(product.variants.map((variant) => variant.options[index]).filter((value) => Boolean(value)))]);
      const variantParam = Number(new URLSearchParams(window.location.search).get("variant"));
      const initialVariantId = Number.isFinite(variantParam) && variantParam > 0 ? variantParam : void 0;
      const initialVariant = product.variants.find((variant) => variant.id === initialVariantId) ?? product.variants.find((variant) => variant.available) ?? product.variants[0];
      this.selectedOptions = [...initialVariant?.options ?? []];
    }
    // ─── Derived state ─────────────────────────────────────────────────────────
    /**
     * Effective quantity rules from the app's metafields: `floor` is the
     * minimum order quantity, `step` the interval the +/- moves in. When no
     * interval is set the minimum doubles as the step — the pre-split
     * behaviour, so products configured before the split work unchanged.
     */
    get quantityRules() {
      const { minQuantity, intervalQuantity } = this.config;
      const floor = minQuantity && minQuantity > 1 ? minQuantity : 1;
      const step = intervalQuantity == null ? floor : intervalQuantity > 1 ? intervalQuantity : 1;
      return { floor, step };
    }
    get selectedVariant() {
      const { product } = this.config;
      return product.variants.find((variant) => variant.options.every((value, index) => value === this.selectedOptions[index])) ?? product.variants[0];
    }
    get tiers() {
      const variant = this.selectedVariant;
      if (!variant) {
        return [];
      }
      const entry = (this.config.quantityBreaks?.quantity_breaks ?? []).find((candidate) => (candidate.variant_ids ?? []).includes(String(variant.id)));
      return entry?.tiers ?? [];
    }
    /**
     * The quantity is the single source of truth: the break select just writes a
     * tier's lower bound into it, and the active tier derives from whatever the
     * quantity is — typed, stepped, or selected. Survives variant switches.
     */
    get quantity() {
      return this.enteredQuantity ?? this.snapToStep(this.tiers[0]?.from ?? this.quantityRules.floor);
    }
    /** The nearest allowed quantity at or above `value`. */
    snapToStep(value) {
      const { floor, step } = this.quantityRules;
      const sane = Number.isFinite(value) && value > 0 ? Math.floor(value) : floor;
      if (sane <= floor) {
        return floor;
      }
      return Math.max(floor, Math.ceil(sane / step) * step);
    }
    // ─── DOM construction (once) ───────────────────────────────────────────────
    buildDom() {
      const { product } = this.config;
      const texts = this.texts;
      const hasOnlyDefaultVariant = product.variants.length === 1 && product.variants[0]?.title === "Default Title";
      const optionFields = product.options.map((optionName, index) => {
        const lastOddItem = product.options.length % 2 === 1 && index === product.options.length - 1;
        const values = this.optionValues[index].map((value) => `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`).join("");
        return `
          <label class="tw:flex tw:flex-col tw:gap-1 tw:min-w-0 ${lastOddItem ? "tw:col-span-2" : ""}">
            <span class="form__label tw:m-0">${escapeHtml(optionName)}</span>
            <div class="select">
              <select class="select__select tw:h-14!" data-option-index="${index}">${values}</select>
              ${ICON_CARET}
            </div>
          </label>`;
      }).join("");
      const summaryColumn = (key, label) => `
      <div class="delivery-info-text tw:min-w-[unset] tw:lg:min-w-[190px]" data-summary-column="${key}">
        <div class="tw:flex tw:flex-col">
          <p class="small-bold">${escapeHtml(label)}</p>
          <p class="medium-bold" data-summary-value="${key}"></p>
          <p class="extrasmall-bold" data-summary-secondary="${key}"></p>
        </div>
      </div>`;
      this.innerHTML = `
      <div class="tw:flex tw:flex-col tw:gap-4">
        <div class="tw:grid tw:grid-cols-[30fr_70fr] tw:gap-3">
          <label class="tw:flex tw:flex-col tw:gap-1 tw:min-w-0" data-quantity-field>
            <span class="form__label tw:m-0">${escapeHtml(texts.labelQuantity)}</span>
            <div class="quantity tw:w-full!">
              <button type="button" class="quantity__button" name="minus" data-quantity-minus aria-label="−${this.quantityRules.step}">${ICON_MINUS}</button>
              <input type="number" class="quantity__input" inputmode="numeric" min="${this.quantityRules.floor}" step="${this.quantityRules.step}" data-quantity-input>
              <button type="button" class="quantity__button" name="plus" data-quantity-plus aria-label="+${this.quantityRules.step}">${ICON_PLUS}</button>
            </div>
          </label>
          <label class="tw:flex tw:flex-col tw:gap-1 tw:min-w-0" data-tier-field>
            <span class="form__label tw:m-0">${escapeHtml(texts.labelBreak)}</span>
            <div class="select">
              <select class="select__select tw:h-14!" data-tier-select></select>
              ${ICON_CARET}
            </div>
          </label>
        </div>
        ${product.options.length > 0 && !hasOnlyDefaultVariant ? `<div class="tw:grid tw:grid-cols-2 tw:gap-3">${optionFields}</div>` : ""}
        <div class="ed-delivery-info-wrapper tw:mb-0! tw:grid tw:grid-cols-3 tw:lg:flex tw:flex-col tw:items-center tw:lg:items-start tw:lg:flex-row tw:flex-wrap" data-summary>
          ${summaryColumn("unit", texts.labelUnitPrice)}
          <span class="spacer tw:hidden tw:lg:block" data-summary-spacer></span>
          ${summaryColumn("fee", texts.labelSetupPrice)}
          <span class="spacer tw:hidden tw:xxl:block"></span>
          ${summaryColumn("total", texts.labelTotal)}
        </div>
        <button type="button" class="button button--full-width button--primary" data-quantity-breaks-cta>${escapeHtml(this.config.isDesignProduct ? texts.ctaDesign : texts.ctaAddToCart)}</button>
      </div>`;
      this.quantityField = this.querySelector("[data-quantity-field]");
      this.quantityInput = this.querySelector("[data-quantity-input]");
      this.tierField = this.querySelector("[data-tier-field]");
      this.tierSelect = this.querySelector("[data-tier-select]");
      this.optionSelects = Array.from(this.querySelectorAll("select[data-option-index]"));
      this.summaryGrid = this.querySelector("[data-summary]");
      this.feeColumn = this.querySelector('[data-summary-column="fee"]');
      this.summarySpacer = this.querySelector("[data-summary-spacer]");
      this.ctaButton = this.querySelector("[data-quantity-breaks-cta]");
      for (const key of ["unit", "fee", "total"]) {
        this.summaryValueElements[key] = {
          value: this.querySelector(`[data-summary-value="${key}"]`),
          secondary: this.querySelector(`[data-summary-secondary="${key}"]`)
        };
      }
    }
    bindEvents() {
      this.querySelector("[data-quantity-minus]").addEventListener("click", () => this.stepQuantity(-1));
      this.querySelector("[data-quantity-plus]").addEventListener("click", () => this.stepQuantity(1));
      this.quantityInput.addEventListener("input", () => {
        this.setQuantity(Number(this.quantityInput.value));
      });
      this.quantityInput.addEventListener("blur", () => {
        this.enteredQuantity = this.snapToStep(this.quantity);
        this.update();
      });
      this.quantityInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.quantityInput.blur();
        }
      });
      this.tierSelect.addEventListener("change", () => {
        this.setQuantity(Number(this.tierSelect.value));
      });
      for (const select of this.optionSelects) {
        select.addEventListener("change", () => {
          this.selectOption(Number(select.dataset.optionIndex), select.value);
        });
      }
      this.ctaButton.addEventListener("click", () => void this.handleCta());
    }
    // ─── State changes ─────────────────────────────────────────────────────────
    setQuantity(next) {
      this.enteredQuantity = Math.max(1, Math.floor(Number.isFinite(next) ? next : 1));
      this.update();
    }
    /** +/- always land on the next allowed multiple above/below the current value. */
    stepQuantity(direction) {
      const current = this.quantity;
      const { floor, step } = this.quantityRules;
      this.enteredQuantity = direction === 1 ? this.snapToStep(current + 1) : Math.max(floor, Math.floor((current - 1) / step) * step);
      this.update();
    }
    /** Switch one option value; if the exact combo doesn't exist, adopt the first variant carrying that value. */
    selectOption(index, value) {
      const { product } = this.config;
      const next = [...this.selectedOptions];
      next[index] = value;
      const exact = product.variants.some((variant) => variant.options.every((optionValue, position) => optionValue === next[position]));
      if (exact) {
        this.selectedOptions = next;
      } else {
        const fallback = product.variants.find((variant) => variant.options[index] === value);
        this.selectedOptions = fallback ? [...fallback.options] : next;
      }
      this.update();
    }
    // ─── Targeted DOM updates ──────────────────────────────────────────────────
    update() {
      const variant = this.selectedVariant;
      if (!variant) {
        return;
      }
      const tiers = this.tiers;
      const quantity = this.quantity;
      const activeTier = tierForQuantity(tiers, quantity);
      const tierPrice = activeTier?.prices?.[this.config.currency];
      const unitPrice = tierPrice !== void 0 ? Number(tierPrice) : variant.price / 100;
      const feePrice = this.config.manufacturingFee ? this.config.manufacturingFee.price / 100 : 0;
      const total = unitPrice * quantity + feePrice;
      if (document.activeElement !== this.quantityInput) {
        this.quantityInput.value = String(quantity);
      }
      this.renderTierSelect(variant, tiers, activeTier);
      this.tierField.classList.toggle("tw:hidden!", tiers.length === 0);
      this.quantityField.classList.toggle("tw:col-span-2", tiers.length === 0);
      for (const select of this.optionSelects) {
        const value = this.selectedOptions[Number(select.dataset.optionIndex)] ?? "";
        if (select.value !== value) {
          select.value = value;
        }
      }
      const hasFee = Boolean(this.config.manufacturingFee);
      this.feeColumn.classList.toggle("tw:hidden!", !hasFee);
      this.summarySpacer.classList.toggle("tw:hidden!", !hasFee);
      this.summaryGrid.classList.toggle("tw:grid-cols-3", hasFee);
      this.summaryGrid.classList.toggle("tw:grid-cols-2", !hasFee);
      this.renderSummaryValue("unit", unitPrice);
      this.renderSummaryValue("fee", feePrice);
      this.renderSummaryValue("total", total);
      this.syncUrl(variant);
      this.announceChange({ variant, activeTier, quantity, unitPrice, total });
    }
    /** Rebuild the tier options only when the variant (and thus its tiers) changed. */
    renderTierSelect(variant, tiers, activeTier) {
      if (this.renderedTiersForVariantId !== variant.id) {
        this.renderedTiersForVariantId = variant.id;
        this.tierSelect.innerHTML = tiers.map((tier) => `<option value="${tier.from}">${escapeHtml(this.breakOptionLabel(tier))}</option>`).join("");
      }
      const placeholder = this.tierSelect.querySelector("option[data-placeholder]");
      if (activeTier) {
        placeholder?.remove();
        this.tierSelect.value = String(activeTier.from);
      } else if (!placeholder) {
        const option = document.createElement("option");
        option.value = "";
        option.hidden = true;
        option.dataset.placeholder = "true";
        this.tierSelect.prepend(option);
        this.tierSelect.value = "";
      }
    }
    /** "0,65 kr. fra 3001 stk" — composed from the theme's own from_item/item_item keys, like the legacy Antal select. */
    breakOptionLabel(tier) {
      const price = tier.prices?.[this.config.currency];
      const fromQuantity = `${this.texts.breakFrom} ${tier.from} ${this.texts.breakUnit}`;
      return price !== void 0 ? `${this.formatMoney(Number(price))} ${fromQuantity}` : fromQuantity;
    }
    /**
     * One summary column: the price, plus an "inkl. moms" line — exactly like
     * the theme's legacy delivery-info block. Moms disabled (e.g. the CH store)
     * shows the price alone.
     */
    renderSummaryValue(key, amount) {
      const { value, secondary } = this.summaryValueElements[key];
      value.textContent = this.formatMoney(amount);
      secondary.textContent = this.config.momsEnabled ? `${this.formatMoney(amount * this.momsMultiplier)} ${this.texts.labelInclTax}` : "";
    }
    /** Keep ?variant= in sync so a reload — or the theme — lands on the same variant. */
    syncUrl(variant) {
      const url = new URL(window.location.href);
      if (url.searchParams.get("variant") !== String(variant.id)) {
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState(window.history.state, "", url);
      }
    }
    /** Announce every change, initial state included, to whatever theme listens. */
    announceChange({ variant, activeTier, quantity, unitPrice, total }) {
      const inclTax = (amount) => amount * this.momsMultiplier;
      this.dispatchEvent(
        new CustomEvent(CHANGE_EVENT, {
          bubbles: true,
          detail: {
            productId: this.config.product.id,
            variantId: variant.id,
            variantTitle: variant.title,
            options: [...this.selectedOptions],
            tier: activeTier ? { from: activeTier.from, to: activeTier.to } : null,
            quantity,
            unitPrice,
            unitPriceInclTax: inclTax(unitPrice),
            total,
            totalInclTax: inclTax(total),
            currency: this.config.currency
          }
        })
      );
    }
    // ─── CTA ───────────────────────────────────────────────────────────────────
    /**
     * With a linked manufacturing-fee product the product is designed in Zakeke
     * first — navigate to the CUSTOMIZER proxy page in its `?pid=` shape (the
     * `/apps/zakeke/c/<handle>` path is the 3D CONFIGURATOR and errors on
     * customizer products). The store-local fee variant id rides along as a URL
     * param, mirrored to sessionStorage as the fallback carrier; the
     * jmband-opstart head snippet picks it up on the designer page and adds the
     * design + exactly one fee line. Without a fee product, plain add to cart.
     */
    async handleCta() {
      const variant = this.selectedVariant;
      if (!variant || this.isSubmitting) {
        return;
      }
      const root = shopifyRoot();
      const cartQuantity = this.snapToStep(this.quantity);
      if (this.config.isDesignProduct) {
        const feeVariantId = this.config.manufacturingFee ? String(this.config.manufacturingFee.variantId) : null;
        if (feeVariantId) {
          try {
            sessionStorage.setItem("jmb_fee", feeVariantId);
          } catch {
          }
        }
        const params = new URLSearchParams({
          pid: String(this.config.product.id),
          handle: this.config.product.handle,
          locale: this.config.locale || "da",
          quantity: String(cartQuantity),
          // Zakeke's proxy reads the variant from `id` — the product form's
          // variant field, since Zakeke's own button GET-submits that form.
          // A `variant` param is ignored (server-renders variantId: null).
          id: String(variant.id),
          ...feeVariantId ? { jmb_fee: feeVariantId } : {}
        });
        window.location.href = `/apps/zakeke?${params}`;
        return;
      }
      this.isSubmitting = true;
      this.ctaButton.disabled = true;
      this.ctaButton.setAttribute("aria-busy", "true");
      try {
        const fee = this.config.manufacturingFee;
        const bundleId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
        const items = fee ? [
          { id: variant.id, quantity: cartQuantity, properties: { _opstart_bundle: bundleId, _opstart_variant: String(fee.variantId) } },
          { id: fee.variantId, quantity: 1, properties: { _opstart: "true", _opstart_bundle: bundleId } }
        ] : [{ id: variant.id, quantity: cartQuantity }];
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          throw new Error(`cart/add failed (${response.status})`);
        }
        window.location.href = `${root}cart`;
      } catch (error) {
        console.error("[quantity-breaks] add to cart failed", error);
        this.isSubmitting = false;
        this.ctaButton.disabled = false;
        this.ctaButton.removeAttribute("aria-busy");
      }
    }
  }
  class ReloadSections {
    constructor() {
      this.reloadCart = this.reloadCart.bind(this);
      this.init = this.init.bind(this);
    }
    init() {
      document.addEventListener("Edition:cart:reload", () => {
        console.log("reloading cart");
        this.reloadCart();
      });
    }
    async reloadCart() {
      try {
        const response = await window.fetch(`${window.Shopify.routes.root_url}?section_id=main-cart-items`);
        if (response.ok) {
          const responseText = await response.text();
          const fresh = document.createElement("div");
          fresh.innerHTML = responseText;
          const miniCart = document.getElementById("main-cart-items");
          miniCart.innerHTML = fresh.innerHTML;
          console.log(fresh.innerHTML);
        } else {
          console.log("Error in reloadCart:", response);
        }
      } catch (error) {
        console.log("Error in reloadCart:", error);
      }
    }
  }
  const CONSENT_STORAGE_KEY = "cookieSelections";
  const isConsentGranted = () => {
    const selections = local.get(CONSENT_STORAGE_KEY);
    return selections?.analytics === true;
  };
  const idleInject = (inject) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(inject);
    } else {
      setTimeout(inject, 0);
    }
  };
  const buildGtmSrc = ({ containerId, serverUrl, scriptName }) => {
    if (serverUrl && scriptName) {
      const encodedId = btoa(`id=${containerId}`).replace(/=+$/, "");
      return `${serverUrl}/${scriptName}?P=${encodedId}&page=1`;
    }
    return `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  };
  class ThemeScripts {
    /** Loads a script according to its strategy. TypeScript narrows to `GtmScriptConfig` when `id: 'gtm'`. */
    load = (config) => {
      if (config.id === "gtm") {
        this.loadGtm(config);
        return;
      }
      const { id, strategy, src, inline, async: isAsync = true, defer = false, attributes = {}, onLoad, onError } = config;
      this.applyStrategy({
        strategy,
        inject: () => this.inject({
          id,
          src,
          inline,
          isAsync,
          defer,
          attributes,
          onLoad,
          onError
        })
      });
    };
    /** Handles GTM-specific setup: dataLayer push, URL building, noscript fallback. */
    loadGtm = (config) => {
      const { containerId } = config.gtmConfig;
      this.applyStrategy({
        strategy: config.strategy,
        inject: () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
            event: "gtm.js"
          });
          this.inject({
            id: "gtm",
            src: buildGtmSrc(config.gtmConfig),
            isAsync: true,
            defer: false,
            attributes: { "data-gtm": containerId },
            onLoad: config.onLoad,
            onError: config.onError
          });
          if (!document.querySelector(`noscript[data-gtm="${containerId}"]`)) {
            const noscript = document.createElement("noscript");
            noscript.dataset.gtm = containerId;
            const iframe = document.createElement("iframe");
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.cssText = "display:none;visibility:hidden";
            noscript.appendChild(iframe);
            document.body.insertAdjacentElement("afterbegin", noscript);
          }
        }
      });
    };
    applyStrategy = ({ strategy, inject }) => {
      switch (strategy) {
        case "immediate": {
          inject();
          break;
        }
        case "on-default-consent-set": {
          window.addEventListener("edition:consent-default-set", () => idleInject(inject), { once: true });
          break;
        }
        case "on-consent-granted": {
          window.addEventListener(
            "edition:consent-default-set",
            () => {
              if (isConsentGranted()) {
                idleInject(inject);
                return;
              }
              const waitForConsent = () => {
                if (!isConsentGranted()) return;
                idleInject(inject);
                window.removeEventListener("edition:consent-updated", waitForConsent);
              };
              window.addEventListener("edition:consent-updated", waitForConsent);
            },
            { once: true }
          );
          break;
        }
        case "idle": {
          idleInject(inject);
          break;
        }
        default: {
          const _exhaustive = strategy;
          console.warn("[ThemeScripts] Unknown strategy:", _exhaustive);
        }
      }
    };
    inject = ({ id, src, inline, isAsync, defer, attributes, onLoad, onError }) => {
      if (document.querySelector(`script[data-script-id="${id}"]`)) {
        return;
      }
      if (inline) {
        inline();
      }
      if (!src) {
        return;
      }
      const script = document.createElement("script");
      script.async = isAsync;
      script.defer = defer;
      script.src = src;
      script.dataset.scriptId = id;
      Object.entries(attributes).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });
      if (onLoad) {
        script.addEventListener("load", onLoad);
      }
      if (onError) {
        script.addEventListener("error", onError);
      }
      document.head.appendChild(script);
    };
  }
  class ABModal extends HTMLElement {
    overlay = null;
    dialog = null;
    listContainer = null;
    onContinueCallback = null;
    requestedText = window["abRequestedText"];
    availableText = window["abAvailableText"];
    constructor() {
      super();
    }
    connectedCallback() {
      this.overlay = this.querySelector(".ab-modal__overlay");
      this.dialog = this.querySelector(".ab-modal__dialog");
      this.listContainer = this.querySelector(".ab-modal__list");
      this.setupEventListeners();
    }
    setupEventListeners() {
      const closeBtn = this.querySelector(".ab-modal__close");
      closeBtn?.addEventListener("click", () => this.hide());
      const cancelBtn = this.querySelector(".ab-modal__btn--cancel");
      cancelBtn?.addEventListener("click", () => this.hide());
      const continueBtn = this.querySelector(".ab-modal__btn--continue");
      continueBtn?.addEventListener("click", () => {
        if (this.onContinueCallback) {
          this.onContinueCallback();
        }
        this.hide();
      });
      this.overlay?.addEventListener("click", () => this.hide());
      document.addEventListener("keyup", (event) => {
        if (event.code === "Escape" && this.hasAttribute("open")) {
          this.hide();
        }
      });
    }
    show(checks, onContinue) {
      this.onContinueCallback = onContinue;
      this.populateList(checks);
      this.setAttribute("open", "");
      document.body.style.overflow = "hidden";
      const continueBtn = this.querySelector(".ab-modal__btn--continue");
      continueBtn?.focus();
    }
    hide() {
      this.removeAttribute("open");
      document.body.style.overflow = "";
      this.onContinueCallback = null;
    }
    populateList(checks) {
      if (!this.listContainer) return;
      this.listContainer.innerHTML = checks.map((check) => {
        const actualTotal = check.actualA + check.actualB;
        if (check.hasSufficientStock) {
          return `
          <li class="ab-modal__item ab-modal__item--available">
            <span class="ab-modal__item-icon ab-modal__item-icon--check">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </span>
            <span class="ab-modal__item-text">
              <span class="ab-modal__color-name">${check.colorName}:</span>
              ${check.requestedAmount} (${check.actualA}A + ${check.actualB}B)
            </span>
          </li>
        `;
        } else {
          return `
          <li class="ab-modal__item ab-modal__item--limited">
            <span class="ab-modal__item-icon ab-modal__item-icon--warning">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
            </span>
            <span class="ab-modal__item-text">
              <span class="ab-modal__color-name">${check.colorName}:</span>
              ${check.requestedAmount} ${this.requestedText} → ${actualTotal} ${this.availableText} (${check.actualA}A + ${check.actualB}B)
            </span>
          </li>
        `;
        }
      }).join("");
    }
  }
  if (!customElements.get("ab-modal")) {
    customElements.define("ab-modal", ABModal);
  }
  var colors = Array.from(document.querySelectorAll(".input_colors"));
  var totalAmountFarver = document.getElementById("farver_antal");
  if (colors.length > 0) {
    let checkInventoryAvailability2 = function(selectedColors, variants) {
      return selectedColors.map((selectedColor) => {
        const colorName = selectedColor.color;
        const requestedAmount = selectedColor.amount;
        const availableA = parseInt(selectedColor.element.dataset.availableA || "0") || 0;
        const availableB = parseInt(selectedColor.element.dataset.availableB || "0") || 0;
        const requestedA = Math.ceil(requestedAmount / 2);
        const requestedB = Math.floor(requestedAmount / 2);
        let actualA = Math.min(requestedA, availableA);
        let actualB = Math.min(requestedB, availableB);
        if (actualA < requestedA && actualB < availableB) {
          const shortfall = requestedA - actualA;
          const extraB = Math.min(shortfall, availableB - actualB);
          actualB += extraB;
        }
        if (actualB < requestedB && actualA < availableA) {
          const shortfall = requestedB - actualB;
          const extraA = Math.min(shortfall, availableA - actualA);
          actualA += extraA;
        }
        const maxAvailable = actualA + actualB;
        const hasSufficientStock = requestedAmount <= maxAvailable;
        return {
          colorName,
          requestedAmount,
          availableA,
          availableB,
          maxAvailable,
          actualA,
          actualB,
          hasSufficientStock
        };
      });
    };
    const productJSON = getProducts().then((data) => {
      return data;
    });
    async function getProducts() {
      let variants = [];
      try {
        const response = await fetch(`${productUrl}.json`);
        if (response.ok) {
          const data = await response.json();
          variants = data.product.variants;
          return variants;
        }
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function getVariants(num) {
      try {
        const variants = await getProducts();
        const filteredVariants = variants.filter((variant) => parseFloat(variant.price) === num);
        let filteredVariantIds = filteredVariants.map((variant) => variant.id);
        let variantInputIds = Array.from(document.querySelectorAll(".variant_ids"));
        for (let i = 0; i < variantInputIds.length; i++) {
          if (i < filteredVariantIds.length) {
            variantInputIds[i].value = filteredVariantIds[i];
          }
        }
        let originalInput = document.querySelector(".quantity__input.ed__values");
        originalInput.value = "0";
      } catch (error) {
        console.log(error);
      }
    }
    for (let color of colors) {
      color.addEventListener("change", function() {
        document.addEventListener("editionVariantChange", () => {
          let customStkPrice = document.getElementById("stkpris-inklmoms");
          let customStkPriceValue = customStkPrice.dataset.stkprisvalue;
          var customStkPriceNum = Number(customStkPriceValue) / 100;
          getVariants(customStkPriceNum);
        });
        let colorInput = this;
        let colorValue = parseInt(this.value);
        let colorAmount = 0;
        if (colorValue % minValue !== 0) {
          colorValue = Math.ceil(colorValue / minValue) * minValue;
          colorInput.value = colorValue.toString();
        }
        if (colorValue == null || colorValue == void 0) {
          colorValue = 0;
        }
        for (let input of colors) {
          colorAmount += parseInt(input.value) || 0;
        }
        let totalFarver = Number(totalAmountFarver.innerHTML);
        totalFarver = colorAmount;
        totalAmountFarver.innerHTML = totalFarver.toString();
        document.dispatchEvent(new Event("color_amount_change"));
        const currentVariantSelector2 = document.querySelector(".select__select.ed__select");
        var possibleOptions = Array.from(currentVariantSelector2.querySelectorAll("option"));
        var quantityValue = colorAmount;
        var selectedOption = null;
        for (var possibleOption of possibleOptions) {
          var optionValue = parseInt(possibleOption.value);
          if (optionValue <= quantityValue) {
            if (!selectedOption || optionValue > parseInt(selectedOption.value)) {
              selectedOption = possibleOption;
            }
          }
          if (selectedOption) {
            var currentSelect = currentVariantSelector2.querySelector('option[selected="selected"]');
            currentSelect.removeAttribute("selected");
            selectedOption.setAttribute("selected", "selected");
            var customChangeEvent = new Event("change");
            document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
          }
        }
      });
    }
    if (window.hasABOptions === true) {
      console.log("Initializing AB options with inventory popup support");
      const addToCartButton = document.querySelector("button[type='submit']");
      addToCartButton.addEventListener("click", async (event) => {
        event.preventDefault();
        await handlePickCorrectABOption();
      });
    } else {
      console.log("No AB options detected");
    }
    async function handlePickCorrectABOption() {
      const allSelectedColors = colors.filter((color) => Number(color.value) > 0);
      if (allSelectedColors.length === 0) {
        alert("Vælg venligst mindst én farve og mængde.");
        return;
      }
      const selectedColors = allSelectedColors.map((color) => ({
        color: color.dataset.variant,
        amount: Number(color.value),
        element: color
      }));
      const variants = await productJSON;
      const inventoryChecks = checkInventoryAvailability2(selectedColors);
      const hasInsufficientStock = inventoryChecks.some((check) => !check.hasSufficientStock);
      if (hasInsufficientStock) {
        const modal = document.querySelector("ab-modal");
        if (modal) {
          modal.show(inventoryChecks, () => {
            proceedToAddToCart(inventoryChecks, variants);
          });
        } else {
          console.error("ab-modal element not found");
        }
      } else {
        await proceedToAddToCart(inventoryChecks, variants);
      }
    }
    async function proceedToAddToCart(inventoryChecks, variants) {
      const variantsToAdd = [];
      const randomCryptoID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      const totalSelectedAmount = inventoryChecks.reduce((acc, check) => acc + check.actualA + check.actualB, 0);
      for (const check of inventoryChecks) {
        if (check.actualA === 0 && check.actualB === 0) continue;
        const colorVariants = variants.filter((variant) => variant.title.includes(check.colorName));
        let maxVariantA = null;
        let maxVariantB = null;
        for (const variant of colorVariants) {
          const number = parseInt(variant.title.split(" ")[0]);
          if (number <= totalSelectedAmount) {
            if (variant.title.endsWith("A")) {
              if (!maxVariantA || number > parseInt(maxVariantA.title.split(" ")[0])) {
                maxVariantA = variant;
              }
            } else if (variant.title.endsWith("B")) {
              if (!maxVariantB || number > parseInt(maxVariantB.title.split(" ")[0])) {
                maxVariantB = variant;
              }
            }
          }
        }
        if (check.actualA > 0 && maxVariantA) {
          variantsToAdd.push({
            id: maxVariantA.id,
            quantity: check.actualA,
            properties: { _farvebundle: randomCryptoID }
          });
        }
        if (check.actualB > 0 && maxVariantB) {
          variantsToAdd.push({
            id: maxVariantB.id,
            quantity: check.actualB,
            properties: { _farvebundle: randomCryptoID }
          });
        }
      }
      if (variantsToAdd.length > 0) {
        console.log("Adding to cart:", variantsToAdd);
        await addVariantsToCart(variantsToAdd);
      }
    }
    async function addVariantsToCart(variants) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: variants
          })
        });
        if (response.ok) {
          const data = await response.json();
          window.location.href = "/cart";
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  class editionLogoList extends HTMLElement {
    constructor() {
      super();
      this.dataset;
      let duration = Number(this.dataset.duration);
      duration = duration * 1e3;
      console.log(duration);
      let amount = Number(this.dataset.amount);
      console.log(amount);
      const logos = this.querySelectorAll(".edition-logolist-logo");
      const logosArray = Array.from(logos);
      const loadBar = document.getElementById("logo-load-bar");
      if (logosArray.length > amount) {
        for (let i = amount; i < logosArray.length; i++) {
          logosArray[i].style.opacity = "0";
          logosArray[i].style.position = "absolute";
        }
      }
      if (loadBar) {
        loadBar.style.width = "0%";
        loadBar.style.transition = `unset`;
        setTimeout(() => {
          loadBar.style.transition = `${duration}ms linear`;
          loadBar.style.width = "100%";
        }, 10);
      }
      const batches = [];
      for (let i = 0; i < logosArray.length; i += amount) {
        batches.push(logosArray.slice(i, i + amount));
      }
      let currentBatchIndex = 1;
      setInterval(() => {
        if (loadBar) {
          loadBar.style.width = "0%";
          loadBar.style.transition = `unset`;
          setTimeout(() => {
            loadBar.style.transition = `${duration - 350}ms ease-in`;
            loadBar.style.width = "100%";
          }, 300);
        }
        for (let logo of logosArray) {
          logo.style.transition = "opacity 350ms linear";
          logo.style.top = "-100000000px";
          logo.style.opacity = "0";
          logo.style.position = "absolute";
        }
        if (currentBatchIndex < batches.length) {
          const currentBatch = batches[currentBatchIndex];
          for (let logo of currentBatch) {
            logo.style.transition = "opacity 750ms ease-in";
            logo.style.top = "unset";
            logo.style.opacity = "1";
            logo.style.position = "relative";
          }
          currentBatchIndex++;
        } else {
          currentBatchIndex = 1;
          const startBatch = batches[0];
          for (let logo of startBatch) {
            logo.style.transition = "opacity 750ms ease-in";
            logo.style.top = "unset";
            logo.style.opacity = "1";
            logo.style.position = "relative";
          }
        }
      }, duration);
    }
  }
  window.customElements.define("edition-logolist", editionLogoList);
  let bundleRemoveBtns = document.querySelectorAll(".bundle_remove");
  for (let btn of bundleRemoveBtns) {
    btn.addEventListener("click", () => {
      let removedItem = btn.closest(".cart-item");
      let bundleID = removedItem.dataset.bundleid;
      let allItems = btn.closest("tbody").querySelectorAll(".cart-item");
      var updates = {};
      for (let item of allItems) {
        let itemID = item.dataset.bundleid;
        if (itemID === bundleID) {
          var itemKey = item.closest(".cart-item").dataset.key;
          console.log(itemKey);
          let quantity = 0;
          updates[itemKey] = quantity;
        }
      }
      async function bundle() {
        try {
          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates
            })
          });
          const data = await response.json();
          if (response.ok) {
            window.location.reload();
          }
        } catch (error) {
          console.error("Error:", error);
        }
      }
      bundle();
    });
  }
  class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      let observeEle = document.getElementById("main-cart-items");
      console.log(observeEle);
      const observer = new MutationObserver(function(mutations) {
        for (let mutation of mutations) {
          if (mutation) {
            console.log("Mutation observed");
            setTimeout(() => {
              updateThreshold();
            }, 500);
          }
          break;
        }
      });
      observer.observe(observeEle, {
        attributes: true,
        childList: true,
        characterData: true
      });
      async function updateThreshold() {
        try {
          const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          });
          const data = await response.json();
          if (response.ok) {
            let cartTotal = data.total_price;
            cartTotal = cartTotal / 100;
            let threshold = document.getElementById("remaning_amount");
            threshold = threshold.dataset.threshold;
            threshold = Number(threshold);
            threshold = threshold / 100;
            let remaningAmount = threshold - cartTotal;
            let remaningAmountElement = document.getElementById("remaning_amount");
            remaningAmountElement.innerHTML = remaningAmount + " " + currencySymbol;
            let percentageBar = document.getElementById("amount_filled");
            let percentageFilled = cartTotal * 100 / threshold;
            percentageBar.style.width = `${percentageFilled}%`;
            if (cartTotal >= threshold) {
              let notFreeShipping = document.getElementById("not_free_shipping");
              let freeShipping = document.getElementById("free_shipping");
              notFreeShipping.classList.add("tw:hidden");
              freeShipping.classList.remove("tw:hidden");
            } else {
              let notFreeShipping = document.getElementById("not_free_shipping");
              let freeShipping = document.getElementById("free_shipping");
              notFreeShipping.classList.remove("tw:hidden");
              freeShipping.classList.add("tw:hidden");
            }
          }
        } catch (error) {
          console.error("Error:", error);
        }
      }
    }
  }
  customElements.define("edition-free-shipping-bar", FreeShippingBar);
  if (window.location.href.indexOf("/cart") != -1) ;
  function formatMoney(amount) {
    const locale = Shopify.locale;
    let localeString;
    if (locale.includes("en")) {
      localeString = "en-US";
    } else {
      localeString = "da-DK";
    }
    const currency = Shopify.currency.active;
    return amount.toLocaleString(localeString, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }
  let minValue$1 = window.minValue;
  var minValueString = minValue$1 != null && minValue$1 != void 0 ? minValue$1.toString() : "1";
  let upDown = window.upDown;
  let moms_enabled = window.moms_enabled;
  let moms;
  if (moms_enabled == false) {
    moms = 1;
  } else {
    moms = window.moms;
  }
  let currencySymbol$1 = window.currencySymbol;
  let opstartsPris = window.opstartsPris;
  let opstartsPrisNum = Number(opstartsPris);
  const productQuantiyInput = document.querySelector(".quantity__input.ed__values");
  const currentVariantSelector = document.querySelector(".select__select.ed__select");
  function setQuantity() {
    if (currentVariantSelector) {
      var variantValue = currentVariantSelector.value;
      productQuantiyInput.setAttribute("data-min", variantValue);
      productQuantiyInput.setAttribute("value", variantValue);
    } else {
      productQuantiyInput.setAttribute("data-min", minValueString);
      productQuantiyInput.setAttribute("value", minValueString);
    }
    setTimeout(() => {
      productQuantiyInput.setAttribute("min", minValueString);
      let minusBtn = productQuantiyInput.previousElementSibling;
      minusBtn.classList.remove("disabled");
    }, 750);
  }
  if (currentVariantSelector) {
    currentVariantSelector.addEventListener("change", function() {
      var variantValue = currentVariantSelector.value;
      productQuantiyInput.setAttribute("value", variantValue);
      productQuantiyInput.value = variantValue;
      var currentSelect = currentVariantSelector.querySelector('option[selected="selected"]');
      currentSelect.removeAttribute("selected");
      var newSelect = currentVariantSelector.options[currentVariantSelector.selectedIndex];
      newSelect.setAttribute("selected", "selected");
    });
  }
  function calculatePrices() {
    var totalPrice = document.getElementById("price_to_replace");
    var totalPriceExMoms = document.getElementById("total_price_to_replace");
    var stkPrice = document.getElementById("stkpris");
    var stkPriceInclTax = document.getElementById("stkpris-inklmoms");
    var nontotalPrice = document.querySelector(".price-item.price-item--regular[data-pricecalc]");
    if (productQuantiyInput) {
      var quantityValue = parseFloat(productQuantiyInput.value);
    }
    var farveAntal = document.getElementById("farver_antal");
    if (farveAntal) {
      var farveAntalNum = Number(farveAntal.innerText);
    }
    var priceValue = Number(nontotalPrice.dataset.pricecalc) / 100;
    if (stkPrice) {
      let stkPriceNum = Number(priceValue.toFixed(2));
      let stkPriceInclTaxNum = Number((priceValue * moms).toFixed(2));
      stkPriceInclTax.dataset.stkprisvalue = nontotalPrice.dataset.pricecalc;
      if (!farveAntal) {
        var totalPriceNum = Number((quantityValue * priceValue).toFixed(2)) + opstartsPrisNum;
        var totalPriceInclMomsNum = (Number((quantityValue * priceValue).toFixed(2)) + opstartsPrisNum) * moms;
      } else {
        var totalPriceNum = Number((farveAntalNum * priceValue).toFixed(2)) + opstartsPrisNum;
        var totalPriceInclMomsNum = (Number((farveAntalNum * priceValue).toFixed(2)) + opstartsPrisNum) * moms;
      }
      let stkPriceLocalNum, stkPriceInvlTaxLocalNum, totalPriceLocalNum, totalPriceLocalInclMomsNum;
      stkPriceLocalNum = formatMoney(stkPriceNum);
      stkPriceInvlTaxLocalNum = formatMoney(stkPriceInclTaxNum);
      totalPriceLocalNum = formatMoney(totalPriceNum);
      totalPriceLocalInclMomsNum = formatMoney(totalPriceInclMomsNum);
      stkPrice.textContent = `${stkPriceLocalNum}`;
      stkPriceInclTax.textContent = `${stkPriceInvlTaxLocalNum}`;
      totalPriceExMoms.textContent = `${totalPriceLocalNum}`;
      totalPrice.textContent = `${totalPriceLocalInclMomsNum}`;
    }
  }
  if (productQuantiyInput) {
    if (productQuantiyInput) {
      setQuantity();
    }
    calculatePrices();
    productQuantiyInput.addEventListener("change", function() {
      setTimeout(() => {
        calculatePrices();
      }, 100);
      const parentSelect = currentVariantSelector;
      const options = Array.from(parentSelect.options);
      var currentSelect = currentVariantSelector.querySelector('option[selected="selected"]');
      var nextSelect = currentSelect.nextElementSibling;
      currentSelect.previousElementSibling;
      let productValue = parseInt(this.value);
      if (nextSelect) {
        if (productValue >= parseInt(nextSelect.value)) {
          const selectedIndex = options.findIndex((option, index) => {
            const nextOption = options[index + 1];
            const optionValue = parseInt(option.value);
            const nextOptionValue = nextOption ? parseInt(nextOption.value) : Infinity;
            return optionValue <= productValue && nextOptionValue > productValue;
          });
          if (selectedIndex !== -1) {
            let currentSelectedOption = parentSelect.querySelector('option[selected="selected"]');
            let selectedOption = parentSelect.options[selectedIndex];
            selectedOption.setAttribute("selected", "selected");
            var customChangeEvent = new Event("change");
            document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
            currentSelectedOption.removeAttribute("selected");
          } else {
            parentSelect.selectedIndex = options.length - 1;
            let currentSelectedOption = parentSelect.querySelector('option[selected="selected"]');
            let selectedOption = parentSelect.options[options.length - 1];
            selectedOption.setAttribute("selected", "selected");
            var customChangeEvent = new Event("change");
            document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
            currentSelectedOption.removeAttribute("selected");
          }
        }
      }
      if (productValue < parseInt(currentSelect.value)) {
        const selectedIndex = options.findIndex((option) => parseInt(option.value) > productValue) - 1;
        if (selectedIndex !== -1) {
          parentSelect.selectedIndex = selectedIndex;
          let currentSelectedOption = parentSelect.querySelector('option[selected="selected"]');
          let selectedOption = parentSelect.options[selectedIndex];
          selectedOption.setAttribute("selected", "selected");
          var customChangeEvent = new Event("change");
          document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
          currentSelectedOption.removeAttribute("selected");
        } else {
          parentSelect.selectedIndex = 0;
          let currentSelectedOption = parentSelect.querySelector('option[selected="selected"]');
          let selectedOption = parentSelect.options[0];
          selectedOption.setAttribute("selected", "selected");
          var customChangeEvent = new Event("change");
          document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
          currentSelectedOption.removeAttribute("selected");
        }
      }
    });
    productQuantiyInput.addEventListener("blur", function() {
      var possibleOptions = Array.from(currentVariantSelector.querySelectorAll("option"));
      var firstOption = possibleOptions[0];
      var firstOptionValue = parseInt(firstOption.value);
      let productValue = parseInt(this.value);
      if (productValue % upDown !== 0) {
        productValue = Math.ceil(productValue / upDown) * upDown;
        productQuantiyInput.value = productValue.toString();
      }
      if (productValue < firstOptionValue) {
        productValue = firstOptionValue;
        productQuantiyInput.value = productValue.toString();
        var currentSelect = currentVariantSelector.querySelector('option[selected="selected"]');
        currentSelect.removeAttribute("selected");
        firstOption.setAttribute("selected", "selected");
        var customChangeEvent = new Event("change");
        document.querySelector("variant-selects").dispatchEvent(customChangeEvent);
      }
    });
    productQuantiyInput.addEventListener("keypress", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        this.dispatchEvent(new Event("blur"));
      }
    });
  }
  document.addEventListener("DOMContentLoaded", () => {
    const interval = setInterval(() => {
      const formSubmit = document.getElementById("zakeke-product-button");
      if (formSubmit) {
        formSubmit.addEventListener("click", setProps);
        clearInterval(interval);
      }
    }, 250);
    const regularAddToCart = document.querySelector(".product-form__submit");
    regularAddToCart?.addEventListener("click", setProps);
  });
  function setProps(event) {
    localStorage.setItem("productTitle", document.getElementById("product_title").textContent);
    localStorage.setItem("itemQty", productQuantiyInput.value);
    localStorage.setItem("stkPris", document.getElementById("stkpris").textContent);
    if (document.getElementById("attr_opstart")) {
      localStorage.setItem("opstartVariantId", document.getElementById("attr_opstart").value);
    }
    let opstartsEle = document.getElementById("opstarts_pris");
    if (opstartsEle) {
      let opstartsValue = opstartsEle.value;
      opstartsValue = `${opstartsValue} ${currencySymbol$1}`;
      localStorage.setItem("opstartsPris", opstartsValue);
    }
    let attrStkPris = Array.from(document.querySelectorAll(".attr_stkPris"));
    for (let attr of attrStkPris) {
      attr.value = document.getElementById("stkpris").textContent;
    }
    let attrBundleId = Array.from(document.querySelectorAll(".attr_bundle_id"));
    if (attrBundleId.length > 0) {
      for (let attr of attrBundleId) {
        attr.value = Date.now().toString();
      }
    }
    const zakekeButtonWrappper = document.querySelector(".product-form__buttons.zakeke-product-button-container");
    const zakekeQuantityInput = zakekeButtonWrappper?.nextElementSibling;
    if (zakekeQuantityInput) {
      zakekeQuantityInput.value = productQuantiyInput.value;
      const closestForm = zakekeButtonWrappper.closest("form");
      closestForm.submit();
    }
  }
  document.addEventListener("editionVariantChange", () => {
    productQuantiyInput.value;
    setQuantity();
    calculatePrices();
  });
  document.addEventListener("color_amount_change", () => {
    calculatePrices();
  });
  if (window.location.href.includes("/products")) {
    localStorage.removeItem("itemQty");
    localStorage.removeItem("stkPris");
    localStorage.removeItem("opstartsPris");
    localStorage.removeItem("productTitle");
    localStorage.removeItem("opstartVariantId");
  }
  const customerCreateForm = document.getElementById("create_customer");
  const cvrField = document.getElementById("RegisterForm-CVR");
  if (customerCreateForm && cvrField) {
    const submitBtn = customerCreateForm.querySelector("button");
    let cvrFieldBorder = cvrField.style.border;
    submitBtn.addEventListener("click", (event) => {
      const value = cvrField.value;
      if (value === "") {
        event.preventDefault();
        cvrField.style.border = "1px solid red";
      }
    });
    cvrField.addEventListener("input", () => {
      cvrField.style.border = cvrFieldBorder;
    });
  }
  const menuItems = Array.from(document.querySelectorAll(".mega-menu"));
  let currentMenuItemIndex;
  menuItems.forEach((menuItem, index) => {
    const content = menuItem.querySelector(".mega-menu__content");
    menuItem.addEventListener("mouseover", (event) => {
      if (currentMenuItemIndex !== void 0 && currentMenuItemIndex !== index || currentMenuItemIndex === 0) {
        menuItems[currentMenuItemIndex]?.removeAttribute("open");
      }
      currentMenuItemIndex = index;
      menuItem.setAttribute("open", "true");
    });
    const closeMenu = () => setTimeout(() => menuItem.removeAttribute("open"), 100);
    menuItem.addEventListener("mouseleave", (event) => content.addEventListener("mouseover", (event2) => clearTimeout(closeMenu())));
    content.addEventListener("mouseleave", closeMenu);
  });
  const stkPrisValue = translateStrings.stkPris;
  const quickAddBtns = Array.from(document.querySelectorAll(".ed-quick-add"));
  let spinner;
  let text;
  let textContent;
  for (let btn of quickAddBtns) {
    btn.addEventListener("click", () => {
      let parent = btn.closest(".quick-add-parent");
      spinner = parent.querySelector(".loading-overlay__spinner");
      text = btn.querySelector(".ed-qucik-add-text");
      textContent = text.textContent;
      spinner.classList.remove("hidden");
      text.classList.add("hidden");
      let quickAddData = {
        quantity: 1,
        id: btn.dataset.variantid,
        properties: {
          [stkPrisValue]: btn.dataset.variantprice
        }
      };
      quickAdd(quickAddData);
    });
  }
  async function quickAdd(quickAddData) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(quickAddData)
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const data = await response.json();
      if (response.ok) {
        console.log(data);
        const addedToCartMessage = document.getElementById("added_to_cart");
        addedToCartMessage.classList.add("added_to_cart_open");
        let added_dialog = addedToCartMessage.querySelector(".added_dialog");
        added_dialog.classList.add("added_dialog_open");
        let img = added_dialog.querySelector("img");
        img.style.opacity = "0";
        img.src = "";
        const addedProducts = document.getElementById("added_products");
        addedProducts.innerHTML = "";
        let name = data.product_title;
        let amount = data.quantity;
        const element = document.createElement("p");
        element.classList.add("added_variant_title");
        element.innerHTML = `${amount} x ${name}`;
        addedProducts.appendChild(element);
        img.style.transition = "opacity 0.3s ease-in-out";
        img.src = data.featured_image.url;
        img.addEventListener("load", () => {
          img.style.opacity = "1";
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      spinner.classList.add("hidden");
      text.classList.remove("hidden");
      text.textContent = "Tilføjet til kurv";
      setTimeout(() => {
        text.textContent = textContent;
      }, 2e3);
    }
  }
  const quantityEle = document.getElementById("quantity-input-edition");
  if (quantityEle) {
    const plusBtn = quantityEle.querySelector('button[name="plus"]');
    plusBtn.addEventListener("click", (event) => {
      const tooltip = document.querySelector(".edition-tooltip");
      tooltip.classList.add("edition-tooltip-visible");
      plusBtn.removeEventListener("click", () => {
      });
      setTimeout(() => {
        tooltip.style.opacity = "0";
        setTimeout(() => {
          tooltip.classList.remove("edition-tooltip-visible");
        }, 1500);
      }, 4500);
    });
  }
  const scripts = new ThemeScripts();
  scripts.load({
    id: "gtm",
    strategy: "on-default-consent-set",
    gtmConfig: {
      containerId: "GTM-WHHQTGJP",
      serverUrl: "https://bumknjgg.eut.stape.net",
      scriptName: "cdjjbumknjgg.js"
    }
  });
  customElements.define("cookie-banner", CookieBanner);
  const reloadSections = new ReloadSections();
  reloadSections.init();
  const googleCookie = new GoogleCookie();
  googleCookie.init();
  customElements.define("geolocator-component", Geolocator);
  customElements.define("remove-button", CartRemoveButton);
  customElements.define("cart-item-quantity-update", CartItemQuantityUpdate);
  customElements.define("quantity-breaks", QuantityBreaks);
})();
